document.addEventListener('DOMContentLoaded', function() {
  // Pause/resume function for video hero section
  let btn = document.getElementById('video-hero-pause-btn');
  if (btn) {
    const interval = setInterval(() => {
      let section = btn.closest('.video-hero');
      let video = section ? section.querySelector('video') : null;
      if (!video) return;

      clearInterval(interval);

      let pauseIcon = btn.querySelector('.video-hero__pause-icon');
      let playIcon = btn.querySelector('.video-hero__play-icon');
      let srText = btn.querySelector('.sr-only');

      btn.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          pauseIcon.style.display = '';
          playIcon.style.display = 'none';
          btn.setAttribute('aria-pressed', 'false');
          srText.textContent = 'Pause';
        } else {
          video.pause();
          pauseIcon.style.display = 'none';
          playIcon.style.display = '';
          btn.setAttribute('aria-pressed', 'true');
          srText.textContent = 'Afspil';
        }
      });

      video.addEventListener('play', function() {
        pauseIcon.style.display = '';
        playIcon.style.display = 'none';
        btn.setAttribute('aria-pressed', 'false');
        srText.textContent = 'Pause';
      });

      video.addEventListener('pause', function() {
        pauseIcon.style.display = 'none';
        playIcon.style.display = '';
        btn.setAttribute('aria-pressed', 'true');
        srText.textContent = 'Afspil';
      });
    }, 200);
  }

  // Pause/resume function for video hero section END


});